<template>
  <header class="header">
    <Logo @click="router.push(`/${prefix}/feed`)" />
    <Icons :prefix="prefix" />
  </header>
</template>

<script setup lang="ts">
import Logo from './Logo.vue';
import NavigationTabs from './NavigationTabs.vue';
import {useRouter} from "vue-router";
const router = useRouter();
import SearchBar from './SearchBar.vue';
import Icons from './Icons.vue';
import { defineProps } from 'vue';
defineProps({
  prefix: String,
})
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 80px;
  background-color: #fff;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
}
</style>
